import { createContext } from 'react';

const historyContext = createContext<string[]>(['', '']);

export default historyContext;
